import { useSyncExternalStore } from "react";
import { useMediaQuery } from "./use-media-query.ts";

export const COARSE_POINTER_QUERY = "(pointer: coarse)";
export const NO_HOVER_QUERY = "(hover: none)";

function subscribeToPlatformChanges() {
    return () => {};
}

export function isMacOsPlatform(platform: string) {
    return /^Mac/i.test(platform);
}

function getIsMacOsPlatform() {
    if (typeof navigator === "undefined") return false;
    const userAgentData = (
        navigator as Navigator & {
            userAgentData?: { platform?: string };
        }
    ).userAgentData;
    const platform =
        userAgentData?.platform ||
        navigator.platform ||
        navigator.userAgent ||
        "";
    return isMacOsPlatform(platform);
}

export function useIsMacOsPlatform() {
    return useSyncExternalStore(
        subscribeToPlatformChanges,
        getIsMacOsPlatform,
        () => false,
    );
}

const IN_APP_BROWSER = /FBAN|FBAV|FB_IAB|Instagram|; wv\)/;

export function isInAppBrowser(userAgent: string) {
    return IN_APP_BROWSER.test(userAgent);
}

function getIsInAppBrowser() {
    return (
        typeof navigator !== "undefined" && isInAppBrowser(navigator.userAgent)
    );
}

export function useIsInAppBrowser() {
    return useSyncExternalStore(
        subscribeToPlatformChanges,
        getIsInAppBrowser,
        () => false,
    );
}

export function useCanUseSmsHandoff() {
    const hasCoarsePointer = useMediaQuery(COARSE_POINTER_QUERY);
    const hasNoHover = useMediaQuery(NO_HOVER_QUERY);
    const isMacOsPlatform = useIsMacOsPlatform();
    return (hasCoarsePointer && hasNoHover) || isMacOsPlatform;
}
